import { render, staticRenderFns } from "./userRelated.vue?vue&type=template&id=566ca863&scoped=true"
import script from "./userRelated.vue?vue&type=script&lang=ts"
export * from "./userRelated.vue?vue&type=script&lang=ts"
import style0 from "./userRelated.vue?vue&type=style&index=0&id=566ca863&prod&lang=css"
import style1 from "./userRelated.vue?vue&type=style&index=1&id=566ca863&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566ca863",
  null
  
)

export default component.exports